module.exports = __webpack_public_path__ + "img/中化蓝天LOGO.249febcb.png";